import { Pointer } from '@yleisradio/areena-types';
import { useCallback, useState } from 'react';
import { useNotificationContext } from '../NotificationContext/NotificationContext';

type State = {
  isOpen: boolean;
  menuSource: Pointer;
  title: string;
  info?: string;
  labels?: string;
};

const initialState = {
  isOpen: false,
  menuSource: {} as Pointer,
  title: '',
};

export function useContextMenuState() {
  const [state, setState] = useState<State>(initialState);
  const { removeAllNotifications, preventNotifications, enableNotifications } =
    useNotificationContext();

  const openContextMenu = useCallback(
    (menuSource: Pointer, title: string, info?: string, labels?: string) => {
      setState(current => ({
        ...current,
        isOpen: true,
        menuSource: menuSource,
        title,
        info,
        labels,
      }));
      removeAllNotifications();
      preventNotifications();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const closeContextMenu = useCallback(() => {
    setState(initialState);
    enableNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    openContextMenu,
    closeContextMenu,
    isOpen: state.isOpen,
    menuSource: state.menuSource,
    title: state.title,
    info: state.info,
    labels: state.labels,
  };
}
